import React, { PureComponent } from 'react';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import get from 'lodash/get';

import Button from '../Button/Button.component';

import text from './ErrorBottomSheet.component.translation';
import config from './ErrorBottomSheet.config';
import './ErrorBottomSheet.less';

class ErrorBottomSheet extends PureComponent {
  _renderButton = () => {
    const {
      btn: { text: singleText, onClick: singleClick },
      intl: { formatMessage },
    } = this.props;

    // Single Button
    if (singleText !== undefined && singleClick !== undefined) {
      return (
        <Button addClass="full primary" action={singleClick} id="btn_single">
          <b>{singleText || formatMessage(text.btnOk)}</b>
        </Button>
      );
    }

    // Dual Button
    const {
      btn: {
        positive: { text: positiveText, onClick: positiveClick },
        negative: { text: negativeText, onClick: negativeClick },
      },
    } = this.props;

    return (
      <div className="dual-button">
        <Button
          className="button"
          id="btn_negative"
          addClass="outline"
          action={negativeClick}
        >
          {negativeText || formatMessage(text.btnCancel)}
        </Button>
        <Button
          className="button"
          id="btn_positive"
          addClass="primary"
          type="button"
          action={positiveClick}
        >
          {positiveText || formatMessage(text.btnOk)}
        </Button>
      </div>
    );
  };
  _renderSectionFooter = () => (
    <section className="footer-sheet">{this._renderButton()}</section>
  );

  _renderImages = () => {
    const { error, visible } = this.props;
    if (error.img && visible) {
      return <img src={get(error, 'img')} alt="no-courier" />;
    }
    return '';
  };

  render() {
    const {
      visible,
      error,
      onChange,
      intl: { formatMessage },
      disableSwipe,
    } = this.props;
    return (
      <div id="error-bottom-sheet">
        <SwipeableBottomSheet
          open={visible}
          onChange={onChange}
          overflowHeight={0}
          bodyStyle={{ borderRadius: '1.6rem 1.6rem 0rem 0rem' }}
          swipeableViewsProps={{
            disabled: disableSwipe,
          }}
        >
          <div className="bottom-sheet">
            <div className="bottom-sheet-body">
              <div className="bottom-sheet-line" />
              <div className="bottom-sheet-content">
                <div className="bottom-sheet-error">
                  <div className="error-image">{this._renderImages()}</div>
                  <span className="error-title">
                    {get(error, 'title') || formatMessage(text.title)}
                  </span>
                  <span className="error-desc">
                    {get(error, 'desc') || formatMessage(text.desc)}
                  </span>
                </div>
              </div>
            </div>

            {this._renderSectionFooter()}
          </div>
        </SwipeableBottomSheet>
      </div>
    );
  }
}

ErrorBottomSheet.displayName = config.displayName;
ErrorBottomSheet.defaultProps = config.defaultProps;
ErrorBottomSheet.propTypes = config.propTypes;

export default ErrorBottomSheet;
